import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/time-card-calculator',
  component: () => import('../../routes/TimeCardCalculator.svelte'),
  card: {
    id: 'time-card-calculator',
    title: 'Time Card Calculator',
    description: 'Calculate weekly pay including regular hours, overtime, and holiday premium with daily breakdown.',
    icon: 'schedule',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/time-card-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Time Card Calculator – Weekly Pay with Overtime & Holiday Pay',
    description: 'Free time card calculator for weekly payroll. Calculate regular hours, overtime (daily and weekly), and holiday premium pay with a day-by-day breakdown.',
  },
};

export default meta;
